import { h } from 'preact'
import { AppRoute } from '../route'
import { AppFrame } from '../../components/frames/AppFrame/AppFrame'
import { ConnectedHeader } from '../../components/Header/Header'
import { PageNotFound } from '../../components/moduler/advarsler/PageNotFound/PageNotFound'

export const pageNotFoundRoute: AppRoute = {
  path: `/valg/2019/resultat/*`,
  widget: false,
  render: () => {
    return (
      <AppFrame>
        <ConnectedHeader />
        <main>
          <PageNotFound />
        </main>
      </AppFrame>
    )
  }
}
